import React, { useState, useEffect } from 'react';
import { Grid, IconButton, Collapse } from '@material-ui/core';

import { styled } from '@material-ui/core/styles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { SdmTypography, SdmSpacer } from 'components';

const CollapseContent = styled('div')({
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});

export const FilterCollapsable = ({
  label,
  children,
  alreadyOpen,
  hideWrapper = false,
  collapseStyle = {},
  labelGridXs = 6,
  arrowGridXs = 6,
}) => {
  const [collapsableCtrl, setCollapsableCtrl] = useState(false);

  useEffect(() => {
    if (alreadyOpen) setCollapsableCtrl(true);
  }, [alreadyOpen]);

  const handleExpandClick = () => {
    setCollapsableCtrl(!collapsableCtrl);
  };

  return (
    <div style={{ borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
      <Grid
        container
        alignItems={'center'}
        style={{ cursor: 'pointer' }}
        onClick={() => handleExpandClick()}
      >
        <Grid item xs={labelGridXs}>
          <SdmTypography margin={0} variant={'h2Regular'}>
            {label}
          </SdmTypography>
        </Grid>
        <Grid item xs={arrowGridXs} style={{ textAlign: 'right' }}>
          <IconButton
            disableFocusRipple
            disableTouchRipple
            disableRipple
            style={{ float: 'right' }}
          >
            {collapsableCtrl ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <SdmSpacer height={10} />
      <Grid container>
        <Collapse in={collapsableCtrl} style={{ ...collapseStyle }}>
          {hideWrapper ? (
            children
          ) : (
            <CollapseContent>{children}</CollapseContent>
          )}
        </Collapse>
      </Grid>
    </div>
  );
};
